import { useQuery } from "@tanstack/react-query";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

import { NavbarApp } from "../../../components";
import { getProfile } from "../../../data";
import AuthStore from "../../../stores/AuthStore";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";

export const AppLayout = (props) => {
  const [fistTimeForMount, setFistTimeForMount] = useState(true);
  const [isSidebarVisible, setSidebarVisible] = useState(true);
  const { data, isSuccess } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });
  useEffect(() => {
    //Todo: for permission control this code writed here, use effect is not good place for this code

    if (isSuccess) {
      if (data != null) {
        if (fistTimeForMount) {
          console.log("isSuccess b", isSuccess);
          AuthStore.setProfile(data.data.user);
        } else {
          console.log("isSuccess c", isSuccess);
        }

        setFistTimeForMount(false);
      }
    }
  }, [fistTimeForMount, isSuccess, data]);

  useEffect(() => {
    if (typeof window === "undefined") return;
    setSidebarVisible(
      window.__SIDEBAR_VISIBLE !== undefined ? window.__SIDEBAR_VISIBLE : true
    );

    const handler = (event) => {
      if (event?.detail?.isVisible !== undefined) {
        setSidebarVisible(event.detail.isVisible);
      }
    };
    window.addEventListener("sidebar-visibility-change", handler);
    return () =>
      window.removeEventListener("sidebar-visibility-change", handler);
  }, []);

  const contentPadding = props.fullscreen
    ? "px-4 md:px-6 lg:px-8"
    : "px-4 md:px-6 lg:px-8";
  const contentOffset = isSidebarVisible ? "md:pl-72 lg:pl-80" : "md:pl-0";

  return (
    <div className="min-h-screen bg-background">
      <NavbarApp />
      <div className={cn("transition-all duration-300", contentOffset)}>
        <header
          className={cn(
            "sticky top-0 z-20 w-full border-b bg-background/80 backdrop-blur-md",
            contentPadding
          )}
        >
          <div className="flex h-16 items-center justify-between gap-4">
            <div
              className={cn(
                "flex-1 min-w-0 pl-12",
                isSidebarVisible && "md:pl-0"
              )}
            >
              <h1 className="text-xl font-semibold tracking-tight text-foreground truncate md:text-2xl">
                {props.title}
              </h1>
            </div>
            {props.actions && props.actions.length > 0 && (
              <div className="flex items-center gap-2">
                {props.actions.map((item) =>
                  item.isHide ? null : (
                    <Button
                      key={item.name}
                      onClick={item.onClick}
                      variant={item.variant || "default"}
                      size={item.size || "default"}
                      className={item.className}
                    >
                      {item.icon && <item.icon className="mr-2 h-4 w-4" />}
                      {item.name}
                    </Button>
                  )
                )}
              </div>
            )}
          </div>
        </header>
        <main className={cn("w-full py-6", contentPadding)}>
          {props.loading && (
            <div className="flex items-center justify-center p-8">
              <div className="text-center">
                <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent motion-reduce:animate-[spin_1.5s_linear_infinite]" />
                <p className="mt-2 text-sm text-muted-foreground">Loading...</p>
              </div>
            </div>
          )}
          {props.children}
        </main>
      </div>
    </div>
  );
};
